// TripShell — layout for all trip routes. Loads TripContext for the :tripId.
import { Outlet } from "react-router-dom";
import { TripProvider } from "../auth/TripContext";
import BottomNav from "./BottomNav";
import ProximityToast from "./ProximityToast";

export default function TripShell() {
  return (
    <TripProvider>
      <Outlet />
      <ProximityToast />
      <BottomNav />
    </TripProvider>
  );
}
